<template lang="pug">
div
  slide-show
  quick-access
  featured-video
  web-canal
  covid
  articles.mb-n10
  communications
  galleries
  projects.mb-n10
  videos
  jean-piaget
  unesco
  v-divider
  instagram
  pop-up
</template>

<script>
import SlideShow from "./SlideShow.vue";
import QuickAccess from "./QuickAccess.vue";
import FeaturedVideo from "./FeaturedVideo.vue";
import WebCanal from "./WebCanal.vue";
import Covid from "./Covid.vue";
import Articles from "./Articles.vue";
import Communications from "./Communications.vue";
import Galleries from "./Galleries.vue";
import Projects from "./Projects.vue";
import Videos from "./Videos.vue";
import JeanPiaget from "./JeanPiaget.vue";
import Unesco from "./Unesco.vue";
import Instagram from "./Instagram.vue";
import PopUp from "@/components/widgets/PopUp";

export default {
  data: () => ({
    banners: {
      topo: 23,
      middle1: 24,
      middle2: 25,
      bottom: 26,
    },
  }),
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    SlideShow,
    QuickAccess,
    FeaturedVideo,
    WebCanal,
    Covid,
    Articles,
    Communications,
    Galleries,
    Projects,
    Videos,
    JeanPiaget,
    Unesco,
    Instagram,
    PopUp,
  },
};
</script>
